import React from 'react'
import { Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import useTeamsSettings from '../../../hooks/useTeamsSettings'
import AddTeamForm from '../../form/forms/AddTeamForm/AddTeamForm'
import ContainerPadding from '../../containerPadding/containerPadding'
import DialogWithCloseIcon from '../../DialogWithCloseIcon/DialogWithCloseIcon'
import mutationType from '../../../types/mutationType'

const AddTeamModal = (props) => {
  const { showAddTeamModal, handleCloseModal, addTeam, updateTeam, teamData, seasonId } = props
  const { gender, ageRestriction, teamLogo, orgId } = useTeamsSettings()

  const isEditMode = Boolean(teamData)

  // Find the matching gender and ageRestriction objects from the available options
  const matchedGender = gender?.find((g) => g.name === teamData?.genderValue)
  const matchedAgeRestriction = ageRestriction?.find(
    (a) => a.name === teamData?.ageRestrictionValue,
  )

  // Transform season team data to match the expected form structure
  const transformedTeamData = teamData
    ? {
        id: teamData.teamId,
        name: teamData.teamName,
        threeLetterIdentifier: teamData.threeLetterIdentifier,
        gender: matchedGender,
        ageRestriction: matchedAgeRestriction,
        color: teamData.color,
        externalId: teamData.externalId,
        logoUrl: teamData.teamLogoUrl,
        clubId: teamData.clubId,
      }
    : null

  return (
    <DialogWithCloseIcon
      open={showAddTeamModal}
      dialogWidth='650px'
      onClose={handleCloseModal}
      dialogTitle={
        <Typography component='div' variant='h6' style={{ fontWeight: 'bold' }}>
          {isEditMode ? 'Edit Team' : 'Add Team'}
        </Typography>
      }
    >
      <ContainerPadding paddingValue='1%'>
        <AddTeamForm
          gender={gender}
          ageRestriction={ageRestriction}
          teamLogo={teamLogo}
          orgId={orgId}
          seasonId={seasonId}
          addTeam={addTeam}
          updateTeam={updateTeam}
          teamData={transformedTeamData}
          isEditMode={isEditMode}
        />
      </ContainerPadding>
    </DialogWithCloseIcon>
  )
}

AddTeamModal.propTypes = {
  showAddTeamModal: PropTypes.bool,
  handleCloseModal: PropTypes.func,
  addTeam: mutationType,
  updateTeam: mutationType,
  teamData: PropTypes.object,
  seasonId: PropTypes.string,
}

export default AddTeamModal
